export default __webpack_public_path__ + "static/media/person-monocular.7863b3f9.svg";